import i18n from 'i18next';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ReactNode, useEffect, useMemo } from 'react';
import { useEffectOnce } from 'usehooks-ts';
import { PathProvider } from '../../../providers/Path/pathProvider';
import { HomePage } from '../../../pages/HomePage/HomePage';
import { PageNotFound } from '../../../pages/PageNotFound/pageNotFound';
import { UserEditorProvider } from '../../../providers/UserEditor/userEditorProvider';
import { GameOverview } from '../../../pages/GameOverview/gameOverview';
import { Games } from '../../../pages/Games/games';
import { User } from '../../../pages/User/user';
import { UserProvider } from '../../../providers/User/userProvider';
import { ScrollToTop } from '../../SctollToTop/sctollToTop';

interface IPage {
	path: string;
	element: ReactNode;
}

/** @deprecated */
export interface ICustomStyle {
	customStyle?: { bg?: string; cta?: string; text?: string };
}

const pages: ReadonlyArray<IPage> = [
	{
		path: '/',
		element: <HomePage />,
	},
	{
		path: '/games',
		element: <Games />,
	},
	{
		path: '/game/:id',
		element: <GameOverview />,
	},
	{
		path: '/user/:id',
		element: (
			<UserProvider>
				<UserEditorProvider>
					<User />
				</UserEditorProvider>
			</UserProvider>
		),
	},
];
const pageFallback = {
	path: '*',
	element: <PageNotFound />,
} as const;

const Wrapper = () => {
	useEffect(() => {
		if (process.env.REACT_APP_ENV === 'production') {
			return;
		}

		document.title = `[DEV] ${document.title}`;
	}, []);

	const pageNodes = useMemo(
		() =>
			pages.map(page => (
				<Route
					path={page.path}
					element={page.element}
					key={page.path}
				/>
			)),
		[pages]
	);
	const pageFallbackNode = (
		<Route
			path={pageFallback.path}
			element={pageFallback.element}
		/>
	);

	useEffectOnce(() => {
		i18n.on('languageChanged', () => window.location.reload());
	});

	return (
		<BrowserRouter>
			<PathProvider>
				{/** @TODO: New container component (game-cap alike) */}
				<ScrollToTop>
					<Routes>
						{pageNodes}
						{pageFallbackNode}
					</Routes>
				</ScrollToTop>
			</PathProvider>
		</BrowserRouter>
	);
};

export default Wrapper;
